$.fn.select2.defaults.set('theme', 'bootstrap');

$.fn.select2.amd.define(
  'ns/select2/selection/search',
  [
    'jquery',
    'select2/utils',
    'select2/selection/search',
  ],
  function ($, Utils, Search) {
    function NsSearch(decorated, $element, options) {
      NsSearch.__super__.constructor.apply(this, arguments);
    }

    var adapter = Utils.Decorate(Search, NsSearch);

    adapter.prototype.resizeSearch = function () {
      this.$search.css('width', '100%');
    };

    return adapter;
  }
);

$.fn.select2.amd.define(
  'ns/select2/selection',
  [
    'select2/utils',
    'select2/selection/single',
    'select2/selection/multiple',
    'select2/selection/placeholder',
    'select2/selection/allowClear',
    'ns/select2/selection/search',
    'select2/selection/eventRelay',
  ],
  function (
    Utils,
    SingleSelection,
    MultipleSelection,
    Placeholder,
    AllowClear,
    SelectionSearch,
    EventRelay,
  ) {
    // Decorates MultipleSelection with Placeholder
    var adapter = Utils.Decorate(MultipleSelection, Placeholder);

    adapter = Utils.Decorate(adapter, EventRelay);
    adapter = Utils.Decorate(adapter, AllowClear);
    adapter = Utils.Decorate(adapter, SelectionSearch);

    return adapter;
  },
);
